import { Pipe, PipeTransform } from '@angular/core';

import { formatTimespanMs, formatTimespanShort, formatTimespanShortMs } from './time-formatter';

@Pipe({ name: 'timespan', standalone: true })
export class TimespanPipe implements PipeTransform {
  public transform(input: number, hours?: boolean, seconds?: boolean): string {
    return formatTimespanShort(input, hours, seconds);
  }
}

@Pipe({ name: 'timespanShort', standalone: true })
export class TimespanShortPipe implements PipeTransform {
  public transform(input: number): string {
    return formatTimespanShortMs(input);
  }
}

@Pipe({ name: 'timespanMs', standalone: true })
export class TimespanMsPipe implements PipeTransform {
  public transform(input: number): string {
    return formatTimespanMs(input);
  }
}
